/**
 * Insurance Eligibility Utility
 * Determines which product categories are eligible for "Assurance Prise de Mesure"
 */

// Categories eligible for measurement insurance
export const ELIGIBLE_CATEGORIES = [
  'store-banne',        // Toile De Store (Home page)
  'store-droit',        // Toile de Store Droit
  'store-double-pente', // Toile de Store à Double Pente
  'lambrequin',         // Lambrequin Seul
];

// Product types that map to eligible categories
export const ELIGIBLE_PRODUCT_TYPES = [
  'toile-store',
  'store-droit', 
  'store-double-pente',
  'lambrequin',
];

// Categories NOT eligible
export const NON_ELIGIBLE_CATEGORIES = [
  'pergola',
  'brise-vue',
  'toile-au-metre',
];

/**
 * Check if a product type is eligible for insurance
 * @param {string} productType - The product type (from URL or product data)
 * @returns {boolean}
 */
export const isInsuranceEligible = (productType) => {
  if (!productType) return true; // Default category (Home) is eligible
  
  const normalizedType = productType.toLowerCase().trim();
  
  // Check if explicitly non-eligible
  if (NON_ELIGIBLE_CATEGORIES.some(cat => normalizedType.includes(cat))) {
    return false;
  }
  
  // Check if eligible
  return ELIGIBLE_PRODUCT_TYPES.some(type => normalizedType.includes(type)) || 
         ELIGIBLE_CATEGORIES.some(cat => normalizedType.includes(cat));
};

/**
 * Check if a page/route is for eligible products
 * @param {string} pathname - Current page pathname
 * @returns {boolean}
 */
export const isPageInsuranceEligible = (pathname) => {
  if (!pathname) return false;
  
  const path = pathname.toLowerCase();
  
  // Non-eligible pages
  if (path.includes('pergola') || 
      path.includes('brise-vue') || 
      path.includes('toile-au-metre')) {
    return false;
  }
  
  // Eligible pages
  if (path === '/' || 
      path.includes('store-droit') || 
      path.includes('store-double-pente') || 
      path.includes('lambrequin')) {
    return true;
  }
  
  return false;
};
